import * as React from "react";

import StudentChoiceCasesList from "./StudentChoiceCasesList";
import { useStudentChoiceCourseSelection } from "./useStudentChoiceCourseSelection";

type TStudentChoiceContentForCompletionModalProps = {
  documentSetListForStudentChoiceCases: TDocumentSetListForStudentChoiceCases;
  documentId?: number;
};

const StudentChoiceContentForCompletionModal = ({
  documentSetListForStudentChoiceCases,
  documentId,
}: TStudentChoiceContentForCompletionModalProps) => {
  const {
    selectedCourseIds,
    loading,
    handleCheckboxChange,
    submitSelectedCourses,
  } = useStudentChoiceCourseSelection(documentId);

  return (
    <div className="completion-modal--student-choice-content-container">
      <StudentChoiceCasesList
        documentSetListForStudentChoiceCases={
          documentSetListForStudentChoiceCases
        }
        style={{ padding: "0 14px" }}
        onCheckboxChange={handleCheckboxChange}
      />

      <div className="completion-modal--student-choice-content-cta-button-container">
        <button
          className="ref-btn"
          disabled={selectedCourseIds.length === 0 || loading}
          onClick={() => {
            submitSelectedCourses();
            document.dispatchEvent(new Event("acknowledgeLowTime"));
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              submitSelectedCourses();
              document.dispatchEvent(new Event("acknowledgeLowTime"));
            }
          }}
        >
          Yes, add to my course
        </button>
        <button
          className="ref-btn ref-secondary-btn"
          type="button"
          onClick={() => {
            document.dispatchEvent(new Event("acknowledgeLowTime"));
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              document.dispatchEvent(new Event("acknowledgeLowTime"));
            }
          }}
        >
          No thanks
        </button>
      </div>
    </div>
  );
};

export default StudentChoiceContentForCompletionModal;
